import FormulaInput, { type CommitMovement, type FormulaInputHandle } from "./FormulaInput";

interface FormulaBarProps {
  cellRef?: string;
  value?: string;
  disabled?: boolean;
  inputRef?: (el: FormulaInputHandle | null) => void;
  onChange?: (value: string) => void;
  onCaretChange?: (caret: number) => void;
  onCommit?: (movement?: CommitMovement) => void;
  onCancel?: () => void;
  onFocusChange?: (focused: boolean) => void;
}

export default function FormulaBar({
  cellRef = "",
  value = "",
  disabled = false,
  inputRef,
  onChange,
  onCaretChange,
  onCommit,
  onCancel,
  onFocusChange,
}: FormulaBarProps) {
  return (
    <div
      data-formula-bar
      data-artis-ui
      data-testid="scratchpad-formula-bar"
      className="flex h-[26px] w-full items-stretch border-[var(--colour-border-default)] border-b bg-[var(--colour-surface-page-default)] text-[12px] text-[var(--colour-text-default)]"
    >
      <div
        data-testid="scratchpad-cell-ref"
        className="flex w-[100px] shrink-0 items-center border-[var(--colour-border-default)] border-r px-2 text-[var(--colour-text-light)]"
      >
        {cellRef}
      </div>
      <div className="flex w-[28px] shrink-0 items-center justify-center border-[var(--colour-border-default)] border-r text-[var(--colour-text-lighter)] italic">
        fx
      </div>
      <FormulaInput
        className="min-w-0 flex-1 translate-y-px"
        value={value}
        disabled={disabled}
        inputRef={inputRef}
        onChange={onChange}
        onCaretChange={onCaretChange}
        onCommit={onCommit}
        onCancel={onCancel}
        onFocus={() => onFocusChange?.(true)}
        onBlur={() => onFocusChange?.(false)}
      />
    </div>
  );
}
